import { IconeCresol, logoCresolVertical200 } from "../Patroc/data";

const imgCresolItem = "https://cresol.com.br/wp-content/uploads/2020/05/Sede-Nacional-Cresoll.jpg";

const descCresol1 = "Fornecendo soluções financeiras com excelência por meio do relacionamento para gerar desenvolvimento dos cooperados, de seus empreendimentos e da comunidade.";
const descCresol2 = "Fazendo parte da Cresol Confederação, que abrange 17 estados e mais de 630 mil cooperados, a Cresol trabalha com foco no atendimento personalizado, fornecendo soluções financeiras para gerar desenvolvimento dos cooperados, de seus empreendimentos e de toda comunidade.";

const imgGuabiju = "https://d13x8u4oijb9vw.cloudfront.net/fazenda-guabiju-logo.png";
const imgGuabijuItem = imgGuabiju;
const descGuabiju1 = "A Fazenda Guabiju foi idealizada por seus sócios investidores no ano de 2008, com o propósito de desenvolver bezerros precoces. Com foco na busca constante por conhecimento e tecnologias aplicadas à produção animal.";
const descGuabiju2 = "Com foco na busca constante por conhecimento e tecnologias aplicadas à produção animal, o nome Guabiju passou a ter destaque e tornou-se referência na região pela confiança e qualidade.";

export const vitralLogo = "https://d13x8u4oijb9vw.cloudfront.net/vitral-logo.png";
const descVitralSul = "A Vitral Sul é uma empresa que atua no ramo vidreiro há 26 anos no Paraná, Santa Catarina e Rio Grande do Sul.";
const descVitralSul1 = "Seus produtos diferenciados atraem a atenção dos mais variados setores: Vidraçaria, Metalúrgicas, Indústrias Moveleiras, Construção Civil, Arquitetos e Decoradores.";

const imgRedeVemViverLogo = "https://d13x8u4oijb9vw.cloudfront.net/redebemviver-logo-150x150.png";
const descRedeBemViver1 = "A Rede Bem Viver iniciou suas atividades em 2001 com 18 lojas varejistas de materiais de construção na Região Sudoeste do Estado do Paraná. A ideia deu certo e a Rede evoluiu atualmente são 56 lojas associadas, sendo em 53 cidades nas regiões do Oeste, Sudoeste Campos Gerais no Paraná e as demais no Oeste Catarinense.";
const descRedeBemViver2 = "A Rede Bem Viver iniciou suas atividades em 2001 com 18 lojas varejistas de materiais de construção na Região Sudoeste do Estado do Paraná. A iniciativa foi dos empresários Flávio Antônio Pagnoncelli e Irineu Leopoldo Pagnoncelli.";

const imgDiferLogo = "https://d13x8u4oijb9vw.cloudfront.net/difer-ferros-logo.png";
const descDifer1 = "Oferece aos clientes uma ampla diversidade em ferros, aços, telhas galvalume, corte e dobra de chapas e uma linha completa de ferramentas, acessórios e abrasivos. Contamos com uma equipe de atendentes e colaboradores capazes de identificar, suprir e satisfazer as necessidades dos clientes, com rapidez e responsabilidade. Além disso, a empresa conta com frota própria de caminhões para agilizar as entregas de produtos.";

const imgSolPrime = 'https://d13x8u4oijb9vw.cloudfront.net/sol-prime.png';
const descSolPrime1 = 'Empresa especializada em vendas, instalação e manutenção de sistemas fotovoltaicos.';

const imgRevesul = 'https://d13x8u4oijb9vw.cloudfront.net/revesul-150x150.png';
const descRevesul = "Concessionária Volkswagen para Francisco Beltrão e região.";

const imgBonetti = 'https://d13x8u4oijb9vw.cloudfront.net/bonetti-agronutri-150x150.png';
const descBonetti = "A empresa comercializa, além de ração, uma imensa variedade de produtos de nutrição animal. Além disso, conta com uma equipe altamente qualificada, formada por médicos veterinários, zootecnistas, agrônomos, técnicos agrícolas, entre outros.";

const imgImraosMachado = 'https://d13x8u4oijb9vw.cloudfront.net/irmaos_machado-150x150.png';
const descIrmaosMachado = "Empresa especializada na produção de estufas agrícolas e assistência técnica a produtores."

const imgOmni = 'https://d13x8u4oijb9vw.cloudfront.net/omni-150x150.png';
const descOmni = "Há 31 anos no mercado, a Omni é uma instituição sólida e reconhecida por possuir um dos melhores serviços de crédito do Brasil.";

const imgCoasul = 'https://d13x8u4oijb9vw.cloudfront.net/coasul-150x150.png';
const descCoasul = 'Somos uma Cooperativa Agroindustrial do Sudoeste Paranaense, comprometida em valorizar a produção local e gerar desenvolvimento de forma sustentável.';

export const dataColab = [
  {
    master: true,
    search: "cresol",
    nome: "Cresol",
    sobreNome: "",
    cargo: "Cooperativa de Crédito",
    descricao1: descCresol1,
    descricao2: descCresol2,
    img: logoCresolVertical200,
    imgItem: imgCresolItem,
    hexa: "#00604f",
    social: {
      facebook: 'coop.cresol',
      instagram: 'cresol.coop'
    },
    link: 'https://www.youtube.com/embed/1tZJusCoQFk',
  },
  {
    master: false,
    search: "cresol-tradicao",
    nome: "Cresol",
    sobreNome: "Tradição",
    cargo: "Cooperativa de Crédito",
    descricao1: descCresol1,
    descricao2: descCresol2,
    img: IconeCresol,
    imgItem: imgCresolItem,
    hexa: "#00604f",
    social: {
      facebook: 'coopcresoltradicao',
      instagram: 'cresoltradicao'
    },
    link: 'https://www.youtube.com/embed/1tZJusCoQFk',
  },
  {
    master: false,
    search: "coasul",
    nome: "Coasul",
    sobreNome: "",
    cargo: "Cooperativa Agroindustrial",
    descricao1: descCoasul,
    descricao2: '',
    img: imgCoasul,
    imgItem: imgCoasul,
    hexa: "#a7d42b",
    social: {
      facebook: 'coasul',
      instagram: 'coasul'
    },
    link: 'https://www.youtube.com/embed/qWGqa_kDKPQ?si=AAN9tL2tqfDCcBaO',
  },
  {
    master: false,
    search: "bonetti-agronutri",
    nome: "Bonetti",
    sobreNome: "Agronutri",
    cargo: "Agropecuária completa",
    descricao1: descBonetti,
    descricao2: '',
    img: imgBonetti,
    imgItem: imgBonetti,
    hexa: "#007138",
    social: {
      facebook: 'bonetti.agronutri',
      instagram: 'bonettiagronutri'
    },
    link: 'https://www.youtube.com/embed/yalMldnTW2I?si=BUa6zuETRnFy_Jxg',
  },
  {
    master: false,
    search: "sol-prime",
    nome: "Sol",
    sobreNome: "Prime",
    cargo: "Energia Solar",
    descricao1: descSolPrime1,
    descricao2: '',
    img: imgSolPrime,
    imgItem: imgSolPrime,
    hexa: "#104143",
    social: {
      facebook: 'solprimeenergiasolar',
      instagram: 'sol.prime'
    },
    link: 'https://www.youtube.com/embed/m-cusYpGMN8?si=EnjWAo8FSyyHh8F4',
  },
  {
    master: false,
    search: "vitral-sul",
    nome: "Vitral",
    sobreNome: "Sul",
    cargo: "Alumínios e Ferragens",
    descricao1: descVitralSul,
    descricao2: descVitralSul1,
    img: vitralLogo,
    imgItem: vitralLogo,
    hexa: "#ffec00",
    social: {
      facebook: 'VitralSul',
      instagram: 'vitralsul'
    },
    link: 'https://www.youtube.com/embed/kf26w4E4d5o?si=lPjiTFeL7O4uNgDZ',
  },
  // {
  //   master: false,
  //   search: "revesul-veiculos",
  //   nome: "Revesul",
  //   sobreNome: "",
  //   cargo: "Concessionária Volkswagen",
  //   descricao1: descRevesul,
  //   descricao2: '',
  //   img: imgRevesul,
  //   imgItem: imgRevesul,
  //   hexa: "#001850",
  //   social: {
  //     facebook: 'revesulrev',
  //     instagram: 'revesul_vw'
  //   },
  //   link: 'https://www.youtube.com/embed/fDRjMhR8upM?si=BCf5OmvKTDp6oQJe',
  // },
   {
    master: false,
    search: "difer-ferros",
    nome: "Difer",
    sobreNome: "Ferros",
    cargo: "Distribuidora de ferro e aço",
    descricao1: descDifer1,
    descricao2: "",
    img: imgDiferLogo,
    imgItem: imgDiferLogo,
    hexa: "#2f3192",
    social: {
      facebook: 'diferferross',
      instagram: 'diferferros'
    },
    link: 'https://www.youtube.com/embed/n3LLjZ0hG40?si=uMpASimFKh7CT6KK',
  },
   
  {
    master: false,
    search: "rede-bem-viver",
    nome: "Rede",
    sobreNome: "Bem Viver",
    cargo: "Seu amigo de construção",
    descricao1: descRedeBemViver1,
    descricao2: descRedeBemViver2,
    img: imgRedeVemViverLogo,
    imgItem: imgRedeVemViverLogo,
    hexa: "#f49b3e",
    social: {
      facebook: 'redebemviveroficial',
      instagram: 'redebemviveroficial'
    },
    link: 'https://www.youtube.com/embed/n3LLjZ0hG40?si=uMpASimFKh7CT6KK',
  },
 {
    master: false,
    search: "omni",
    nome: "Omni",
    sobreNome: "",
    cargo: "Soluções Financeiras",
    descricao1: descOmni,
    descricao2: '',
    img: imgOmni,
    imgItem: imgOmni,
    hexa: "#ff780c",
    social: {
      facebook: '',
      instagram: 'agenteomni.beltrao.cascavel'
    },
    link: 'https://www.youtube.com/embed/A8YZwVZCmZY?si=vGPXKsWWnaRr9Y1O',
  },
  {
    master: false,
    search: "irmaos-machado",
    nome: "Irmãos",
    sobreNome: "Machado",
    cargo: "Estufas Agrícolas",
    descricao1: descIrmaosMachado,
    descricao2: '',
    img: imgImraosMachado,
    imgItem: imgImraosMachado,
    hexa: "#00552a",
    social: {
      facebook: 'agrop.irmaosmachado',
      instagram: 'irmaosmachado.estufas'
    },
    link: 'https://www.youtube.com/embed/tCIbQYAJrfI?si=2N-2BKOUGzD8nrua',
  },
  {
    master: false,
    search: "fazenda-guabiju",
    nome: "Fazenda",
    sobreNome: "Guabiju",
    cargo: "Fazenda de Bovinos",
    descricao1: descGuabiju1,
    descricao2: descGuabiju2,
    img: imgGuabiju,
    imgItem: imgGuabijuItem,
    hexa: "#45392b",
    social: {
      facebook: 'fazendaguabiju',
      instagram: 'guabiju_silagem'
    },
    link: 'https://www.youtube.com/embed/SOedDdEaAnQ?si=e705RPBnwPNIMryG',
  },
  
];


export const styleGrid = {
  width: "100%",
  margin: 0
}

export const propStyleGrid = {
  container: true,
  style: styleGrid
};